import FillPattern from "ol-ext/style/FillPattern";
import { Fill, Icon, RegularShape, Stroke, Style } from "ol/style";
import CircleStyle from "ol/style/Circle";
import { defaultIcons, objIconsMock } from './mockCustomIcons';

const defaultIconsDirectory = '../../../assets/icons/svg_symbols';

let currentStyle;

export function findIconURL(icon: string){
  if(!icon.includes('/')){
      return defaultIcons[icon]
  }

  const [folder, iconUrl] = icon.split('/');
  if(!folder || !iconUrl) return;

  if(folder === 'mdi'){
    return defaultIcons[iconUrl]
  }
  return `${defaultIconsDirectory}/${folder}/${iconUrl}.svg`;
}

export function findObjectOfIcon(folder: string){
  return objIconsMock.find((obj) => obj.folderName === folder);
}

function getIconFromURL(url: string, tamanhoPonto: number): Icon {
  const parser = new DOMParser();
  const serializer = new XMLSerializer();

  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, false);
  xhr.send(null);

  const svgContent = xhr.responseText;

  const svgDocument = parser.parseFromString(svgContent, 'image/svg+xml');

  const importedSVG = svgDocument.documentElement;

  importedSVG.setAttribute('fill', currentStyle.fill);
  importedSVG.setAttribute('stroke', currentStyle.color);
  importedSVG.setAttribute('stroke-width', `${currentStyle.espessuraLinha}px`);

  const svgString = serializer.serializeToString(importedSVG);
  const urlSVG = `data:image/svg+xml;base64,${btoa(svgString)}`;

  return new Icon({
    anchor: [0.5, 0.5],
    src: urlSVG,
    scale: 0.1 * tamanhoPonto,
  });
}

function getCustomIconForOL(folder: string, icon: string, tamanhoPonto: number) {
  if (!folder || !icon) {
    return undefined;
  }
  const locationSVG = `${defaultIconsDirectory}/${folder}/${icon}.svg`;
  const { fillIcons } = findObjectOfIcon(folder) || {};
  
  if(fillIcons){
    return getIconFromURL(locationSVG, tamanhoPonto);
  }else{
    return new Icon({
      anchor: [0.5, 0.5],
      src: locationSVG,
      scale: 0.1 * tamanhoPonto
    })
  }
}

export function generateDefaultStyle(item: any){
  const color = item.cor || 'black';
  const width = item.espessura || 1;
  const radius = +item.tamanhoPonto || 7;
  const tipoLinha = item.tipoLinha ? item.tipoLinha : '0';
  const lineDashToConvert = tipoLinha.split(',');
  const lineDash = [];
  lineDashToConvert.forEach((eachNumber) => {
    eachNumber = +eachNumber.trim();
    lineDash.push(eachNumber as never);
  });

  let defaultfill = new Fill({
    color: item.preenchimento || 'rgba(240,240,240, 0.3)'
  });

  let fill = defaultfill

  if (item.fillPattern) {
    const { pattern, size, spacing, angle, scale, offset, color } =
      item.fillPattern;
    fill = new FillPattern({
      pattern,
      ratio: 1,
      color,
      fill: defaultfill,
      size,
      spacing,
      angle,
      scale,
      offset
    });
  }

  const stroke = new Stroke({
    color,
    width,
    lineDash
  });

  const strokePoint = new Stroke({
    color,
    width
  });

  // point styles
  const pointStyles = {
    square: new RegularShape({
      fill,
      stroke: strokePoint,
      points: 4,
      radius,
      angle: Math.PI / 4
    }),
    circle: new CircleStyle({
      fill,
      stroke: strokePoint,
      radius
    }),
    triangle: new RegularShape({
      fill,
      stroke: strokePoint,
      points: 3,
      radius,
      rotation: Math.PI / 4,
      angle: 59.975
    }),
    star: new RegularShape({
      fill,
      stroke: strokePoint,
      points: 5,
      radius,
      radius2: 4,
      angle: 0
    }),
    cross: new RegularShape({
      fill,
      stroke: strokePoint,
      points: 4,
      radius,
      radius2: 0,
      angle: 0
    }),
    x: new RegularShape({
      fill,
      stroke: strokePoint,
      points: 4,
      radius,
      radius2: 0,
      angle: Math.PI / 4
    })
  };
  let image;
  if(!!item.simboloPonto){
    currentStyle = {fill: item.preenchimento, color, tamanhoPonto: radius, espessuraLinha: width}
    const [folder, simboloPonto] = item.simboloPonto.split('/');
    image = pointStyles[item.simboloPonto] ||  pointStyles[simboloPonto] || getCustomIconForOL(folder, simboloPonto, radius) || pointStyles.circle;
  }else{
    image = pointStyles.circle
  }

  return new Style({
    image,
    stroke,
    fill
  });
}


